import React, { useEffect, useState } from 'react'
import CustomPostJobButtonToAdd from '../../../../Components/CustomPostJobButtonToAdd/CustomPostJobButtonToAdd'
import PostJob from './PostJob'
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast, ToastContainer } from 'react-toastify';
import PostJobViewModal from './PostJobViewModal';

const PostJobHome = () => {

  const tableData = [
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },
    { campusName: "Cygnusa", eventTitle: 'Celebration', evenetStartDate: "28-12-2025", evenetEndDate: "30-12-2025" },

  ];
  const tableHeadData = ['S.No', 'Company Name', 'Job Title', 'Job Type', 'Skills', "Actions"]


  const dispatch = useDispatch();

  const { JobPostGetAll } = useSelector(state => state?.JobPostGetAll);
  console.log(JobPostGetAll?.data, "JobPostGetAllJobPostGetAll")
  const { addpostjob } = useSelector(
    (state) => state?.addpostjob
  );

  const { deleteJobById } = useSelector(
    (state) => state?.deleteJobById
  );

  const [rowTableData, setRowTableData] = useState([])
  console.log(rowTableData, "rowTableTAdatatattattat")

  const [loading, setLoading] = useState(false);
  const sessionUserId = sessionStorage.getItem("userId")


  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {

      const data1 = {
        data: {},
        method: "get",
        apiName: `getJobsByUserId/${sessionUserId}`,
      };

      const responseData = await dispatch(actions.JOBPOSTGETALL(data1));
      // if (responseData?.payload?.message === "Events Fetched successfully!") {

      // }
      console.log(responseData, "responseDataaa")
      // setResponseTableData(responseData?.payload)

    }


    fetchData();

  }, [addpostjob, deleteJobById]);

  useEffect(() => {
    const tempArr = [];

    JobPostGetAll?.data?.map((data, index) => {
      return tempArr.push({
        id: data?.job_id,
        company_name: data?.company_name || '--',
        job_title: data?.job_title || '--',
        job_type: data?.job_type || '--',
        // skills: data?.skills || '--',
        skills: Array.isArray(data?.skills) && data.skills.length > 0
          ? data.skills.join(', ')
          : '--',


      });
    });
    setRowTableData(tempArr);


  }, [JobPostGetAll]);

  const handleDeletePost = async (id) => {
    const data1 = {
      data: {
        user_id: Number(sessionUserId)
      },
      method: "delete",
      apiName: `deleteJobById/${id}`,
    };

    const responseData = await dispatch(actions.DELETEJOBBYID(data1));
    if (responseData?.payload?.message === "Job deleted successfully.") {
      toast.success("Job deleted successfully.")

    }
    else {
      toast.error(responseData?.payload?.message)
    }
  }

  const handleViewModal = async (id) => {
    const data1 = {
      data: {},
      method: "get",
      apiName: `getJobById/${id}`,
    };

    const responseData = await dispatch(actions.GETJOBBYID(data1));
   
  }





  return (
    <div>

      <CustomPostJobButtonToAdd addComponent={PostJob} title="Posted Job Vacancy Details"  handleViewModal={handleViewModal} componentModalName={PostJobViewModal} handleDeletePost={handleDeletePost} buttonText="Click here to post job" tableData={rowTableData} tableHeadData={tableHeadData} />
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  )
}

export default PostJobHome